import { render } from "./DashUserIndex.vue?vue&type=template&id=f8978c4e"
import script from "./DashUserIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DashUserIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/dash_user/components/DashUserIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8978c4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8978c4e', __exports__)) {
    api.reload('f8978c4e', __exports__)
  }
  
  module.hot.accept("./DashUserIndex.vue?vue&type=template&id=f8978c4e", () => {
    api.rerender('f8978c4e', render)
  })

}


export default __exports__